<template>
  <!-- <div v-if="this.$store.getters.currentUserIsVisitor">
    <VisitorsMerchantList></VisitorsMerchantList>
  </div> -->
  <div >
    <business-registration></business-registration>
  </div>
</template>

<script>
import BusinessRegistration from '@/components/businessInformation/form/BusinessRegistration.vue';
//import VisitorsMerchantList from '../components/VisitorsMerchantList.vue';
export default {
  components: {
    BusinessRegistration,
   //// VisitorsMerchantList,
  },
};
</script>

<style></style>
